export type ConfigFieldKeyType =
    | 'maxSingleWithdrawalTrigger'
    | 'maxSingleDepositTrigger'
    | 'maxTotalWithdrawalTriggerUnderThreshold'
    | 'maxTotalWithdrawalTriggerOverThreshold'
    | 'maxTotalDepositTriggerUnderThreshold'
    | 'maxTotalDepositTriggerOverThreshold'
    | 'drMaxTotalWithdrawalTriggerUnderThreshold'
    | 'drMaxTotalWithdrawalTriggerOverThreshold'
    | 'drMaxTotalDepositTriggerUnderThreshold'
    | 'drMaxTotalDepositTriggerOverThreshold';

export const configFieldLabels: Record<ConfigFieldKeyType, string> = {
    maxSingleWithdrawalTrigger: 'Max Single Withdrawal Trigger',
    maxSingleDepositTrigger: 'Max Single Deposit Trigger',
    maxTotalWithdrawalTriggerUnderThreshold: 'Max Total Withdrawal Trigger (Under Threshold)',
    maxTotalWithdrawalTriggerOverThreshold: 'Max Total Withdrawal Trigger (Over Threshold)',
    maxTotalDepositTriggerUnderThreshold: 'Max Total Deposit Trigger (Under Threshold)',
    maxTotalDepositTriggerOverThreshold: 'Max Total Deposit Trigger (Over Threshold)',
    drMaxTotalWithdrawalTriggerUnderThreshold: 'DR Max Total Withdrawal Trigger (Under Threshold)',
    drMaxTotalWithdrawalTriggerOverThreshold: 'DR Max Total Withdrawal Trigger (Over Threshold)',
    drMaxTotalDepositTriggerUnderThreshold: 'DR Max Total Deposit Trigger (Under Threshold)',
    drMaxTotalDepositTriggerOverThreshold: 'DR Max Total Deposit Trigger (Over Threshold)',
};

export const configFieldKeys: ConfigFieldKeyType[] = [
    'maxSingleWithdrawalTrigger',
    'maxSingleDepositTrigger',
    'maxTotalWithdrawalTriggerUnderThreshold',
    'maxTotalWithdrawalTriggerOverThreshold',
    'maxTotalDepositTriggerUnderThreshold',
    'maxTotalDepositTriggerOverThreshold',
    'drMaxTotalWithdrawalTriggerUnderThreshold',
    'drMaxTotalWithdrawalTriggerOverThreshold',
    'drMaxTotalDepositTriggerUnderThreshold',
    'drMaxTotalDepositTriggerOverThreshold',
];
